import { coverFeatures, type CoverFeature } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

interface FeatureCardProps {
  feature: CoverFeature;
  variant?: "stacked" | "wide";
}

function FeatureCard({ feature, variant = "stacked" }: FeatureCardProps) {
  const isWide = variant === "wide";

  return (
    <a
      href="#collections"
      className={`group h-full flex bg-background-50 rounded-lg border border-background-200 overflow-hidden cursor-pointer hover:border-primary-300 transition-colors ${
        isWide ? "flex-col md:flex-row" : "flex-col"
      }`}
    >
      <div className={`relative overflow-hidden ${isWide ? "w-full md:w-2/5 aspect-[4/3] md:aspect-auto md:min-h-[280px]" : "w-full aspect-[4/3]"}`}>
        <img
          src={feature.image}
          alt={`${feature.title} - 黑料网吃瓜现场`}
          title={`${feature.title} 黑料网吃瓜合集`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/95 text-xs font-medium text-foreground-900">
          {feature.tag}
        </span>
      </div>

      <div className="p-4 md:p-6 flex flex-col flex-1">
        <h3 className="font-heading text-lg md:text-2xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
          {feature.title}
        </h3>
        <p className="mt-2 md:mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{feature.desc}</p>
        <div className="mt-4 md:mt-5 pt-4 border-t border-background-100 flex items-center justify-between gap-3">
          <span className="text-xs text-foreground-500">{feature.meta}</span>
          <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
            阅读
            <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
          </span>
        </div>
      </div>
    </a>
  );
}

export default function CoverFeatures() {
  const [first, second, third] = coverFeatures;

  return (
    <section id="covers" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            label="Cover Features"
            title="封面专题：值得慢慢读的深度整理"
            desc="把碎片信息拼成能读的版本，黑料网吃瓜合集负责把前后因果和关键节点都摆出来。"
          />

          <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
            <div className="lg:col-span-7">
              <FeatureCard feature={first} />
            </div>
            <div className="lg:col-span-5">
              <FeatureCard feature={second} />
            </div>
            <div className="lg:col-span-12">
              <FeatureCard feature={third} variant="wide" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}